import IconMinus from 'assets/icons/minus.svg';
import IconPlus from 'assets/icons/plus.svg';
import cn from 'classnames';
import { m } from 'framer-motion';
import React from 'react';

interface TabsAccordeonNewProps {
  id: string;
  isOpen: boolean;
  onClick: () => void;
  title: React.ReactNode;
  content: React.ReactNode;
  index: number;
}

/**
 * Generic accordeon component
 */
const TabsAccordeonNew: React.FC<TabsAccordeonNewProps> = ({
  id,
  isOpen,
  onClick,
  title,
  content,
  index,
}) => {
  return (
    <>
      <button
        aria-controls={id}
        aria-selected={isOpen ? 'true' : 'false'}
        className={cn(
          'flex  w-full items-center justify-between border-b border-grey-100 py-3 text-left first:border-t hover:text-other-black focus:outline-hidden '
        )}
        data-test={id}
        id={id}
        onClick={onClick}
        role="tab"
      >
        <h3>{title}</h3>
        <m.span
          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-grey-100 text-text-primary"
          animate={{
            rotate: isOpen ? 0 : 180,
          }}
          transition={{ duration: 0.5 }}
        >
          {isOpen ? (
            <IconMinus className="w-3" />
          ) : (
            <IconPlus className="w-3" />
          )}
        </m.span>
      </button>
      <div
        aria-labelledby={id}
        className={cn(
          'border-b border-grey-100 focus:outline-hidden',
          isOpen ? 'block' : 'hidden'
        )}
        data-test={id}
        id={`${id}-tab`}
        role="tabpanel"
        tabIndex={index}
      >
        {content}
      </div>
    </>
  );
};

export default TabsAccordeonNew;
